import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import api from "@/lib/api";

const CategoriesPage = () => {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10" data-testid="categories-page">
      <div className="overline mb-4">Categories</div>
      <h1 className="font-display text-5xl font-black tracking-tight text-ink md:text-6xl">
        Shop by category
      </h1>

      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {cats.map((cat) => (
          <Link
            key={cat.id}
            to={`/products?category=${cat.slug}`}
            data-testid={`categories-card-${cat.slug}`}
            className="arel-card group relative overflow-hidden rounded-2xl"
          >
            <div className="relative aspect-[4/3]">
              <img
                src={cat.image_url}
                alt={cat.name}
                className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="font-display text-2xl font-bold text-white">{cat.name}</div>
              <p className="mt-2 text-sm text-white/80 line-clamp-2">{cat.description}</p>
              <div className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-white group-hover:text-[#ffb6c9]">
                Browse <ChevronRight className="h-4 w-4" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoriesPage;
